import { useMutation } from '@grandvisionhq/graphql';
import { NewsletterSubscribeStatus } from '../__generated__/sharedTypes.js';
import { NEWSLETTER_SUBSCRIBE } from '../operations/mutations/newsletter-subscribe.js';

const useNewsletterSubscribe = ()=>{
    const [newsletterSubscribe, { data , error: error1 , loading  }] = useMutation(NEWSLETTER_SUBSCRIBE, {
        onError: (error)=>{
            console.error(`Error occurred while executing the newsletter mutation: ${error}`);
        }
    });
    const { failures , status  } = (data === null || data === void 0 ? void 0 : data.newsletterSubscribe) || {};
    /**
   * The `AuthorizationFailure` failure occurs when the logged in user tries to submit a different email address.
   */ const hasAuthorizationFailure = !!(failures === null || failures === void 0 ? void 0 : failures.find((failure)=>failure.__typename === 'AuthorizationFailure'
    ));
    const onSubmit = ({ email  })=>{
        newsletterSubscribe({
            variables: {
                input: {
                    email
                }
            }
        });
    };
    return {
        hasAuthorizationFailure,
        hasError: !!error1 || !!(failures === null || failures === void 0 ? void 0 : failures.length),
        hasSubscribed: status === NewsletterSubscribeStatus.SUCCESS,
        isLoading: loading,
        onSubmit
    };
};

export { useNewsletterSubscribe };
//# sourceMappingURL=use-newsletter-subscribe.js.map
